// extracted by mini-css-extract-plugin
export default {"ratingTitle":"ModalEditRating_ratingTitle__nPn4Z","ratingText":"ModalEditRating_ratingText__3C7nS"};